export class HubConfig {
    url!: string;
    hubName!: string;
    channel!: string;
}
